/* eslint-disable no-param-reassign */
import React, {
    useCallback, useMemo, useContext,
    useState
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { InputNumberField, Icon } from '@jutro/legacy/components';
import { Link } from '@jutro/router';
import styles from './PercentageComponent.module.scss';
import metadata from './PercentageComponent.metadata.json5';
import { TranslatorContext } from '@jutro/legacy/locale';

function PercentageComponent(props) {

    const {
        data: PercentageVM,
        updateWizardData,
        submissionVM,
        PercentagePath
    } = props;
    const translator = useContext(TranslatorContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const[total, setTotal] = useState(0);

    const addPercentage = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            PercentageVM.value = PercentageVM.value || []

            const { _xCenter, _dtoName } = PercentageVM;

            const PercentageObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            PercentageVM.isValidationReq.value = true;

            PercentageVM.pushElement(
                PercentageObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, PercentageVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            PercentageVM.value.splice(index, 1);
            _.set(submissionVM.value, PercentagePath, PercentageVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, PercentagePath, PercentageVM?.value]
    );

    const calculateTotalPercentage = (val, changedPath, index) => {
        let sum = 0

        PercentageVM.value.forEach(element => {
            if (!_.isUndefined(element.chiund12Fie)) {
                sum += element.chiund12Fie
            }

            if (!_.isUndefined(element.peobettheageof12to18Fie)) {
                sum += element.peobettheageof12to18Fie
            }

            if (!_.isUndefined(element.peooveorattheageoff18Fie)) {
                sum += element.peooveorattheageoff18Fie
            }
        })
        setTotal(sum);
        PercentageVM.value[0].totFie = sum;
        handleValueChange(val, changedPath, index);
    }

    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow, consistent-return
        (item, index, props) => {
            const { path } = props;

            if (path === 'chiund12Fie') {
                const value = !_.isUndefined(item.chiund12Fie) ? item.chiund12Fie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.chiund12Fie = val;
                            calculateTotalPercentage(val, changedPath, index)
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'peobettheageof12to18Fie') {
                const value = !_.isUndefined(item.peobettheageof12to18Fie) ? item.peobettheageof12to18Fie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.peobettheageof12to18Fie = val;
                            calculateTotalPercentage(val, changedPath, index)
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'peooveorattheageoff18Fie') {
                const value = !_.isUndefined(item.peooveorattheageoff18Fie) ? item.peooveorattheageoff18Fie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.peooveorattheageoff18Fie = val;
                            calculateTotalPercentage(val, changedPath, index)
                        }}
                        value={value}
                        minValue={0}
                    />
                );
            }

            if (path === 'totFie') {
                const value = !_.isUndefined(item.totFie) ? item.totFie : '';

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={total === 0 ? value : total}
                        readOnly
                    />
                );
            }
        }, [handleValueChange, translator, PercentageVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`PercentageTable`]: {
            data: PercentageVM.value,
        }

    }), [PercentageVM?.value])

    const resolvers = {
        resolveCallbackMap: {
            addPercentage,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            PercentageVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [PercentageVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={PercentageVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

PercentageComponent.propTypes = wizardProps;
export default withRouter(PercentageComponent);
